import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LicenseVm, IssueLicenseDto, RenewLicenseDto, UpgradeLicenseDto, CancelLicenseDto, LicenseStatus } from '../models';
import { enumName } from '../utils/enum.util';

@Injectable({ providedIn: 'root' })
export class LicenseService {
  private http = inject(HttpClient);
  private base(tenantId: string) { return `${environment.apiBaseUrl}/tenants/${tenantId}/licenses`; }

  private normalize(l: LicenseVm): LicenseVm {
    return { ...l, status: enumName(LicenseStatus, l.status) };
  }

  getCurrent(tenantId: string): Observable<LicenseVm> {
    return this.http.get<LicenseVm>(`${this.base(tenantId)}/current`).pipe(map((l) => this.normalize(l)));
  }

  issue(tenantId: string, dto: IssueLicenseDto): Observable<LicenseVm> {
    return this.http.post<LicenseVm>(`${this.base(tenantId)}/issue`, dto).pipe(map((l) => this.normalize(l)));
  }

  renew(tenantId: string, dto: RenewLicenseDto): Observable<LicenseVm> {
    return this.http.post<LicenseVm>(`${this.base(tenantId)}/renew`, dto).pipe(map((l) => this.normalize(l)));
  }

  suspend(tenantId: string): Observable<void> {
    return this.http.post<void>(`${this.base(tenantId)}/suspend`, {});
  }

  cancel(tenantId: string, dto: CancelLicenseDto): Observable<void> {
    return this.http.post<void>(`${this.base(tenantId)}/cancel`, dto);
  }

  upgrade(tenantId: string, dto: UpgradeLicenseDto): Observable<LicenseVm> {
    return this.http.post<LicenseVm>(`${this.base(tenantId)}/upgrade`, dto).pipe(map((l) => this.normalize(l)));
  }
}
